import { Box } from '@mui/material'
import * as React from 'react'
import {
    ListAltIcon,
    OndemandVideoIcon,
    TvIcon,
    HomeIcon,
} from '@/shared/ui/Icons'
import { TopMenuButton } from '@/shared/ui/TopMenuButton'
import { useTopMenu } from '@/widgets/TopMenu/hooks/useTopMenu'
import { tvPagePath } from '@/shared/constants/tvConstants'
import { epgPagePath } from '@/shared/constants/epgConstants'
import { vodPagePath } from '@/shared/constants/vodConstants'
import { homePagePath } from '@/shared/constants/homeConstants'
import { useAppStore, useTVStore, useVisibilityStore } from '@/shared/store'
import {
    epgIconStyle,
    homeIconStyle,
    tvIconStyle,
    vodIconStyle,
} from './menuButtonsIconsStyles'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

const MenuButtons = () => {
    const {
        isTvContentVisible,
        isVodContentVisible,
        isEpgContentVisible,
        isHomeContentVisible,
    } = useVisibilityStore()
    const { isPIPMode } = useTVStore()
    const { isUserLoggedIn, devicesLimitExceeded } = useAppStore()
    const { handleTvClick, handleEpgClick, handleVodClick, handleHomeClick } =
        useTopMenu()
    const { pathname } = useLocation()
    const [isTVActive, setIsTVActive] = useState(false)

    useEffect(() => {
        if (isTvContentVisible && isPIPMode && pathname !== tvPagePath) {
            setIsTVActive(false)
        } else if (isTvContentVisible && pathname !== tvPagePath) {
            setIsTVActive(false)
        } else if (pathname !== tvPagePath) {
            setIsTVActive(false)
        } else {
            setIsTVActive(true)
        }
    }, [isTvContentVisible, isPIPMode, pathname])

    return (
        <Box
            display="flex"
            gap={{ xs: '20px', md: '30px' }}
            mr={!isUserLoggedIn ? '140px' : 0}>
            <TopMenuButton
                dataTestId="home-button"
                onClickFunction={handleHomeClick}
                buttonText="HOME"
                buttonIcon={<HomeIcon />}
                active={isHomeContentVisible}
                destination={homePagePath}
                isDisabled={!isUserLoggedIn || devicesLimitExceeded}
                customIconStyle={homeIconStyle}
            />
            <TopMenuButton
                dataTestId="tv-button"
                onClickFunction={handleTvClick}
                buttonText="TV"
                buttonIcon={<TvIcon />}
                active={isTVActive}
                destination={tvPagePath}
                isDisabled={!isUserLoggedIn || devicesLimitExceeded}
                customIconStyle={tvIconStyle}
            />
            <TopMenuButton
                dataTestId="epg-button"
                onClickFunction={handleEpgClick}
                buttonText="EPG"
                buttonIcon={<ListAltIcon />}
                active={isEpgContentVisible}
                destination={epgPagePath}
                isDisabled={!isUserLoggedIn || devicesLimitExceeded}
                customIconStyle={epgIconStyle}
            />
            <TopMenuButton
                dataTestId="vod-button"
                onClickFunction={() => handleVodClick(true)}
                buttonText="VOD"
                buttonIcon={<OndemandVideoIcon />}
                active={isVodContentVisible}
                destination={vodPagePath}
                isDisabled={!isUserLoggedIn || devicesLimitExceeded}
                customIconStyle={vodIconStyle}
            />
        </Box>
    )
}

export { MenuButtons }
